/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "../../components/BaseCom";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import L from "../../components/Lang";
import { Link } from "react-router-dom";
import FormInput from "../../components/FormInput";
import { qreq } from "../../shared/qrequest";

class LoginModal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    async componentDidMount() {
        await this.getSettings();
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    submit = async (e) => {
        e?.preventDefault();
        try {
            let j = await qreq.postAsync('/api/auth/forgot-password', this.state.info);
            if (j.errorCode === 0) {
                this.success('Email has been sent.');
                this.props.onHide();
            }
            else
                this.warn(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }


    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header>
                <Modal.Title>
                    <L>Forgot your Password?</L>
                </Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <FormInput model={this.state.info} name="email" label="Username / Email" type="text" onChange={this.change} />
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-success"><L>Request Reset</L></button>
                    <span role="button" className="btn" onClick={this.props.onLogin}><L>Login</L></span>
                </Modal.Footer>
            </form>
        </Modal>
    }
}

export default withParamsAndNavigate(LoginModal);